/**
 * Keep a list in step with a save when the next fetch is still stale.
 * A patch stays until a fetch returns the same values. A removed id stays
 * out until a fetch no longer includes it.
 * CommonJS only. No object spread: the production bundle cannot load Babel's spread helper.
 */

function mergeSavedRows(rows, patches) {
  const list = Array.isArray(rows) ? rows : [];
  if (!patches || typeof patches.get !== 'function') return list.slice();
  return list.map((row) => {
    if (!row || !patches.has(row.id)) return row;
    const patch = patches.get(row.id);
    const stale = Object.keys(patch).some((key) => row[key] !== patch[key]);
    if (!stale) patches.delete(row.id);
    return stale ? Object.assign({}, row, patch) : row;
  });
}

function includePendingRows(rows, pending) {
  const list = Array.isArray(rows) ? rows.slice() : [];
  if (!pending || typeof pending.forEach !== 'function') return list;
  const seen = new Set(list.map((row) => row && row.id).filter(Boolean));
  const extra = [];
  pending.forEach((row, id) => {
    if (!id || seen.has(id)) {
      pending.delete(id);
      return;
    }
    if (row) extra.push(row);
  });
  return extra.concat(list);
}

function vendorCardFromApplication(application, sponsorId, vendorId) {
  const source = application || {};
  const trades = Array.isArray(source.trades) ? source.trades.filter(Boolean) : [];
  const category = trades[0] || 'General';
  return {
    id: vendorId,
    agent_id: sponsorId,
    created_by: sponsorId,
    name: String(source.business_name || '').trim() || 'Vendor',
    category,
    categories: trades.length ? trades : [category],
    type: 'maintenance',
    phone: source.phone || 'Not provided',
    email: source.email || null,
    website: source.website || null,
    description: source.description || '',
    visibility: 'personal',
    team_id: null,
  };
}

function sameDeclinedVendor(vendor, application, vendorId) {
  if (!vendor) return false;
  if (vendorId && vendor.id === vendorId) return true;
  if (!application) return false;
  const name = String(application.business_name || '').trim().toLowerCase();
  if (!name || String(vendor.name || '').trim().toLowerCase() !== name) return false;
  const email = String(application.email || '').trim().toLowerCase();
  const vendorEmail = String(vendor.email || '').trim().toLowerCase();
  if (email && vendorEmail && email !== vendorEmail) return false;
  return true;
}

function withoutDeclinedVendors(rows, application, vendorId, removed) {
  const list = Array.isArray(rows) ? rows : [];
  const kept = [];
  for (let index = 0; index < list.length; index += 1) {
    const row = list[index];
    if (sameDeclinedVendor(row, application, vendorId)) {
      if (row && row.id && removed && typeof removed.add === 'function') removed.add(row.id);
      continue;
    }
    kept.push(row);
  }
  return kept;
}

function projectRows(rows, patches, removed) {
  const raw = Array.isArray(rows) ? rows : [];
  const ids = new Set(raw.map((row) => row && row.id));
  if (removed && typeof removed.forEach === 'function') {
    removed.forEach((id) => {
      if (!ids.has(id)) removed.delete(id);
    });
  }
  return mergeSavedRows(raw, patches).filter((row) => !removed || !removed.has(row.id));
}

function fieldValue(form, name, fallback) {
  const node = form && form.elements ? form.elements.namedItem(name) : null;
  if (node && typeof node.value === 'string') return node.value;
  return fallback;
}

module.exports = {
  mergeSavedRows,
  includePendingRows,
  vendorCardFromApplication,
  sameDeclinedVendor,
  withoutDeclinedVendors,
  projectRows,
  fieldValue,
};
